import React from "react";
import { useAuth } from "@/context/AuthContext";
import { ShieldOff, LogOut } from "lucide-react";

export default function NoOrganization() {
  const { user, logout } = useAuth();
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-slate-50 p-6" data-testid="no-organization-state">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-rose-50">
          <ShieldOff className="h-7 w-7 text-rose-500" />
        </div>
        <h1 className="text-xl font-bold text-slate-900">Accès révoqué</h1>
        <p className="mt-2 text-sm text-slate-500">
          Votre accès à l'organisation a été retiré. Contactez un administrateur de votre
          établissement pour rétablir votre accès.
        </p>
        {user?.email && (
          <p className="mt-3 text-xs text-slate-400">Connecté en tant que {user.email}</p>
        )}
        <button
          onClick={logout}
          data-testid="no-organization-logout"
          className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-slate-800"
        >
          <LogOut className="h-4 w-4" /> Se déconnecter
        </button>
      </div>
    </div>
  );
}
